module.exports = __webpack_public_path__ + "img/Luluu_Small_logo.fb389d52.svg";